
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"14","cy":"14","r":"14","fill":"#100E2A"}}),_c('path',{attrs:{"d":"M20.732 9.296a.999.999 0 00-1.42 0l-7.45 7.46-3.13-3.14a1.023 1.023 0 00-1.42 1.47l3.84 3.84a1.002 1.002 0 001.42 0l8.16-8.16a1 1 0 000-1.47z","fill":"#fff"}})])
          )
        }
      }
    